import { TwilioActions } from "../constants/actionTypes"

function init(): Record<string, any> {
	return {}
}

export const twilioReducer = (state: Record<string, any> = init(), action: any): Record<string, any> => {
	switch (action.type) {
		case TwilioActions.SET_HAS_PATIENT_JOINED_TWILIO_CONSULT:
			return {
				...state,
				hasPatientJoinedTwilioConsult: action.payload,
			}
		default:
			return state
	}
}
